export var DEFAULT_USER_SORT = "lastName,firstName,email";
/**
 * Page size of the search-as-you-type pickers (organization / user). Since DB-876 the backend lists answer 50
 * records by default and at most 100, so the pickers ask for the largest page explicitly; a longer search term
 * narrows the rest.
 */
export var PICKER_LIMIT = 100;
export var PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
export var DEFAULT_PAGE_SIZE = 20;
export var PAGE_SIZE_STORAGE_KEY = "br-users.pageSize";
export var NK_ORG_UUID = '5bfaf1b9-247f-4a48-adb0-6de859c3fe97';
